import React from 'react';
import { ItemWithTranslation } from 'types/swagger';
import classNames from 'classnames';
import { isNotEmpty } from 'utility/functions';
import styles from './ScommesseEsitoSkeleton.module.scss';

export type ScommesseEsitoSkeletonPropsType = ItemWithTranslation<{
  text?: string;
  header?: string;
}> & {
  size?: string;
  style?: React.CSSProperties;
  testId?: string;
  className?: string;
  isMarcatori?: boolean;
};

export const ScommesseEsitoSkeleton = ({
  size,
  text,
  style,
  testId,
  className,
  isMarcatori,
}: ScommesseEsitoSkeletonPropsType) => (
  <div
    data-key={'sport-skeleton'}
    className={classNames(styles.container, className, size ? styles[size] : '')}
    data-testid={testId}
    data-kind={'betting-option'}
    suppressHydrationWarning
  >
    <button
      type="button"
      style={style}
      className={classNames(styles.wrapper, {
        [styles.minHeight]: isMarcatori,
      })}
      disabled={true}
      suppressHydrationWarning
    >
      {isNotEmpty(text) && <span suppressHydrationWarning>{text}</span>}
    </button>
  </div>
);
